import { Controller } from "@hotwired/stimulus";
import NotificationsSubscription from "../../channels/notifications_subscription";

// Bridges server-side AI-chat broadcasts to the decoupled Decor AI-chat widget.
//
// The server (AiIntegrations::*::ProcessMessageJob) broadcasts `{ai_chat: ...}`
// payloads over NotificationsChannel. The Decor::Suite::AiChat::Widget controller
// is consumer-agnostic: it only reacts to a `decor-ai-chat:broadcast` window
// event and leaves the channel wiring to the host app. This controller is that
// wiring — without it the widget sends messages but never receives the reply.
export default class extends Controller {
  static identifier: string;

  static setIdentifier(identifier: string) {
    this.identifier = identifier;
  }

  private notificationsSubscription!: NotificationsSubscription;
  private boundCallback: ((data: any) => void) | null = null;

  connect() {
    this.notificationsSubscription = NotificationsSubscription.getInstance();
    this.boundCallback = (data: any): void => {
      if (data && data.ai_chat) {
        window.dispatchEvent(
          new CustomEvent("decor-ai-chat:broadcast", { detail: data }),
        );
      }
    };
    this.notificationsSubscription.addCallback(this.boundCallback);
  }

  disconnect() {
    if (this.boundCallback && this.notificationsSubscription) {
      this.notificationsSubscription.removeCallback(this.boundCallback);
    }
  }
}
